/*
* - package up js (run through webpack/others?)
* - split template into 3 platforms, add to concepts cloud
* - update content
* - update stylesheet
* - enable platform switcher
*/

import { icons, platforms } from './svg-icons.js';

const changelog = document.querySelector('.changelog');
const timeline = document.querySelector('.timeline');
const spoilerBtn = document.querySelector('#spoiler-btn');
const newRelease = document.querySelector('.new-release');
const pastReleases = document.querySelectorAll('.past-release');

const stroke = {
  start: { x: 19, y: 3 }, //y generated
  end: { x: 19, y: 800 }, //y generated
  origin: null, //set once
  viewbox: { width: 38, height: 0 }, //current
  segmentLength: 180,
  strokeStyle: getComputedStyle(document.documentElement).getPropertyValue('--theme-light-blue'),
  lineCap: 'round',
  lineWidth: 4,
  points: [],
  scale: 1.0, //stretch out the line as we open/close sections
  path: ''
};

const iconSize = {
  width: 28,
  height: 28
}

//init
const timeSVG = document.querySelector('#timeline-svg');
fitSVGToParent();

const timePath = createSVG('path', {
  'stroke': stroke.strokeStyle,
  'stroke-width': stroke.lineWidth,
  'stroke-linecap': stroke.lineCap,
  'vector-effect': 'non-scaling-stroke',
  'd': genTimePath()
});
timeSVG.appendChild(timePath);

const timeIcons = [
  drawTimeIcon(icons.spoiler, spoilerBtn),
  drawTimeIcon(icons.new, newRelease)
];
pastReleases.forEach((item, i) => {
  timeIcons.push(drawTimeIcon(icons.past, item));
});
updateTimeIcons();

function updateTimeIcons() {
  const timelineOffset = changelog.offsetLeft - timeline.offsetLeft;
  timeIcons.forEach((item, i) => {
    let length = item.parentElement.offsetTop - timeline.offsetTop + (iconSize.height / 2);
    //there's always going to be some inaccuracy later in the line here, as the height is not a true indication of length on a curved path
    // could improve using a bisector: https://observablehq.com/@oluckyman/point-on-a-path-detection or "dirty pixel" color picker, or https://github.com/signavio/svg-intersections#readme
    // or https://codepen.io/netsi1964/pen/yKagwx/ or https://stackoverflow.com/questions/42070839/intersection-of-2-svg-paths
    // or is it faster to getPointAtLength until it matches the Y height we're after?
    // let lPos = getPointAtHeight(length);
    let lPos = timePath.getPointAtLength(length);
    //if the height we hit is different from the height we set, subtract it from the length for a more accurate option
    lPos = timePath.getPointAtLength(length - (lPos.y - length));
    let iconOffset = (item.parentElement.id == 'spoiler-btn') ? 4 : 0; //account for border
    item.style.left = Math.round(-(timelineOffset + iconOffset + (iconSize.width / 2)) + lPos.x) + 'px'; //animated by css
  });
};

// //given two paths (timePath + x line), find the intersecting point
// function getPointAtHeight(height) {
//   console.log(height, timeline);
//   if (height > timeline.clientHeight || height <0) return false;
//   //find the segment that passes through the height
//   let lp, prev = { x: 0, y: 0 };
//   for (const pt of stroke.points) {
//     console.log(pt);
//     if (pt.y > height) {
//       //pt 1 = imaginary line at height, pt 2 = stroke segment
//       console.log(0, height, timeline.clientWidth, height, prev.x, prev.y, pt.x, pt.y);
//       return intersect(0, height, timeline.clientWidth, height, prev.x, prev.y, pt.x, pt.y);
//     }
//     prev = pt;
//   }
// }
//
// // line intercept math by Paul Bourke http://paulbourke.net/geometry/pointlineplane/
// // Determine the intersection point of two line segments
// // Return FALSE if the lines don't intersect
// function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
//   // Check if none of the lines are of length 0
// 	if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) return false;
// 	let denominator = ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
//   // Lines are parallel
// 	if (denominator === 0) return false;
// 	let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
// 	let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;
//   // is the intersection along the segments
// 	if (ua < 0 || ua > 1 || ub < 0 || ub > 1) return false;
//   // Return a object with the x and y coordinates of the intersection
//   let x = x1 + ua * (x2 - x1);
//   let y = y1 + ua * (y2 - y1);
//   return {x, y};
// }

//collapsing
[...document.querySelectorAll('.readmore')].forEach((item, i) => {
  item.addEventListener('click', function() {
    let cid = (item.dataset.contentId !== undefined) ? document.getElementById(item.dataset.contentId) : item.previousElementSibling;
    let collapsed = cid.clientHeight;
    cid.style.height = (collapsed) ? 0 : cid.scrollHeight + "px";
    let readMore = (item.id == 'spoiler-btn') ? item.nextElementSibling.nextElementSibling : item;
    readMore.innerText = (collapsed) ? 'Read More' : 'Read Less';
    setTimeout(updatePath, 270);
  })
});
[...document.querySelectorAll('h3.timeline-header a')].forEach((item, i) => {
  item.addEventListener('click', function(e) {
    e.preventDefault();
    item.parentElement.parentElement.querySelector('.readmore').click();
  })
});


function updatePath() {
  //make sure the bounding box is set properly
  fitSVGToParent();

  // went with the approach of scaling the existing path, rather than generating a new path and animating
  // (as mobile safari will trigger resize events while scrolling, this movement gets distracting)
  stroke.scale = stroke.viewbox.height / stroke.origin.height;
  stroke.path = pathFromPointsScaled(stroke.points, stroke.scale);
  timePath.setAttributeNS(null, 'd', stroke.path);

  updateTimeIcons();
}

let rTimer;
window.addEventListener('resize', e => {
  clearTimeout(rTimer);
  rTimer = setTimeout(updatePath, 50);
});

//color theme switching (for svgs)
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
  //const timePathColor = event.matches ? '#2D5070' : '#A1D2EE'; //dark, light
  const timePathColor = getComputedStyle(document.documentElement).getPropertyValue('--theme-light-blue');
  timePath.setAttributeNS(null, 'stroke', timePathColor);

  const bgColor = getComputedStyle(document.documentElement).getPropertyValue('--bg-main-color');
  [...document.querySelectorAll('.timeline-bg')].forEach((item, i) => {
    item.setAttributeNS(null, 'fill', bgColor);
  });
});

//friendlier svg creation
function createSVG(n, v) {
  n = document.createElementNS("http://www.w3.org/2000/svg", n);
  for (var p in v) {
    n.setAttributeNS(null, p, v[p]);
  }
  return n;
};

//draw icons
function drawTimeIcon(icon, el) {
  const container = document.createElement('div');
  container.style.width = iconSize.width;
  container.style.height = iconSize.height;
  container.classList.add('timeline-icon');
  el.prepend(container); //need a container to get offsets (svg doesn't support)

  const svg = createSVG('svg', {
    width: iconSize.width,
    height: iconSize.height,
    viewbox: `0 0 ${iconSize.width} ${iconSize.height}`,
    fill: 'none',
    style: 'transition: 0.5s; transition-timing-function: ease-in;'
  });
  container.append(svg);

  const circle = createSVG('circle', {
    cx: iconSize.width/2,
    cy: iconSize.height/2,
    r: iconSize.width/2,
    fill: getComputedStyle(document.documentElement).getPropertyValue('--bg-main-color'),
    class: 'timeline-bg'
  });
  svg.appendChild(circle);

  const path = createSVG('path', {
    d: icon.path,
    fill: icon.fill,
    'fill-rule': icon.fillRule,
    'clip-rule': icon.clipRule,
    transform: `translate(${(iconSize.width/2) - (icon.width/2)} ${(iconSize.height/2) - (icon.height/2)})`
  });
  svg.appendChild(path);

  return container;
}

//generate a curvy base path
function genTimePath() {
  let lastPoint = stroke.start;
  stroke.points.push(stroke.start);
  const segments = stroke.viewbox.height / stroke.segmentLength;
  for (var i = 0; i <= segments; i++) {
    let newPoint = {
      x: rand(stroke.start.x - 5, stroke.start.x + 5), // +/- 5 left/right
      y: lastPoint.y + stroke.segmentLength,
      r: rand(-20, -40) // control handle
    };
    //close it off centered and exact length
    if (newPoint.y > stroke.end.y) {
      newPoint.x = stroke.end.x;
      newPoint.y = stroke.end.y;
    }
    stroke.points.push(newPoint);
    lastPoint = newPoint;
  }
  stroke.path = pathFromPointsScaled(stroke.points, stroke.scale);
  return stroke.path;
}

function pathFromPointsScaled(points, scale) {
  let path = ``;
  points.forEach((item, i) => {
    path += (i == 0) ? `M ${item.x} ${item.y} ` : `S ${item.x + 5} ${Math.round((item.y + item.r) * scale)} ${item.x} ${Math.round(item.y * scale)} `;
  });
  return path;
}

//set canvas / stroke sizes dynamically
function fitSVGToParent() {
  stroke.viewbox.width = timeline.getBoundingClientRect().width;
  stroke.viewbox.height = 0;
  [...changelog.children].forEach((item, i) => {
    stroke.viewbox.height += item.getBoundingClientRect().height;
  });
  if (stroke.origin == null) {
    stroke.origin = Object.assign({}, stroke.viewbox); //copy
  }
  timeSVG.setAttribute('viewBox', `0 0 ${stroke.viewbox.width} ${stroke.viewbox.height}`);
  //set start/end points based on width / height
  stroke.start.x = stroke.end.x = stroke.viewbox.width / 2;
  stroke.end.y = stroke.viewbox.height - 1;
}

function rand(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

//go to param if available
{
  let frag = window.location.hash.substr(1);
  if (frag.length >0) {
    let tel = document.getElementById(window.location.hash.substr(1));
    if (typeof tel !== undefined) {
      tel.parentElement.scrollTo({ behavior: 'smooth' });
      tel.parentElement.querySelector('.readmore').click();
    }
  }
}
